/**
 * Formata o tratamento formal do cliente Caring (18/02/2026).
 *
 * Regra combinada com o utilizador:
 *   sex === "F"  → "Senhora Dona <nome>"
 *   sex === "M"  → "Senhor <nome>"
 *   sex vazio    → só "<nome>"
 *
 * Aplica-se a todas as comunicações que chegam ao cliente: proposta,
 * plano de cuidados público, DAF, emails, PDFs. NÃO substitui a
 * terminologia legal do contrato ("2.º Outorgante — Beneficiário") nem
 * a Requisição de Recrutamento (documento RH interno).
 */
export function formatClientAddress(name, sex) {
  const n = (name || "").trim();
  if (!n) return "";
  const s = (sex || "").toString().trim().toUpperCase();
  if (s === "F") return `Senhora Dona ${n}`;
  if (s === "M") return `Senhor ${n}`;
  return n;
}

/** Substantivo genérico substituto de "Beneficiário".  */
export const CLIENT_LABEL = "Cliente";
export const CLIENT_LABEL_PLURAL = "Clientes";
